<div class="content-container">
  <form [formGroup]="form" (ngSubmit)="submitForm()" style="width: 100%" class="wrapper">
    <div *ngIf="!editBanner" class="edit-title">Create Banner</div>
    <div *ngIf="editBanner" class="edit-title">
      <div style="flex-grow: 1">Edit '{{ editBanner.title }}'</div>
      <div
        class="status"
        [ngClass]="statusClass(editBanner.status)"
        style="flex-shrink: 1; margin-right: 15px"
      >
        {{ editBanner.status }}
      </div>
    </div>

    <div class="field-box">
      <div class="field-number">
        <span>1</span>
      </div>
      <div class="field-title">Banner Title*</div>
      <div class="field-input">
        <input
          pInputText
          class="input-text"
          placeholder="Input Title"
          formControlName="title"
          maxlength="100"
        />
        <small class="text-danger" *ngIf="f.title.hasError('required')">Title is required</small>
        <div class="field-subtitle">max 100 characters</div>
      </div>
    </div>
    <!-- end of field 1 -->

    <div class="field-box">
      <div class="field-number">
        <span>2</span>
      </div>
      <div class="field-title">Description*</div>
      <div class="field-input">
        <textarea
          pInputTextarea
          formControlName="description"
          style="width: 100%; height: 48px"
          class="input-text"
          placeholder="Input Description"
          maxlength="1024"
        ></textarea>
        <!--        <input-->
        <!--          pInputText-->
        <!--          class="input-text"-->
        <!--          placeholder="Input Description"-->
        <!--          formControlName="description"-->
        <!--          style="width: 100%"-->
        <!--          maxlength="1024"-->
        <!--        />-->
        <small class="text-danger" *ngIf="f.description.hasError('required')"
          >Description is required</small
        >
        <div class="field-subtitle">max 1024 characters</div>
      </div>
    </div>
    <!-- end of field 2 -->

    <div class="field-box">
      <div class="field-number">
        <span>3</span>
      </div>
      <div class="field-title">Banner Category</div>
      <div class="field-input">
        <p-dropdown
          name="categories"
          [options]="bannerCategories"
          formControlName="bannerCategoryId"
          [style]="{ width: '250px' }"
        ></p-dropdown>
      </div>
    </div>
    <!-- end of field 3 -->

    <div class="field-box">
      <div class="field-number">
        <span>4</span>
      </div>
      <div class="field-title">Display*</div>

      <div class="field-input">
        <p-radioButton name="display" [value]="+1" formControlName="displayType" id="displayDraft">
        </p-radioButton>
        <label for="displayDraft" class="ml-2">
          <b>Draft Banner</b>
          <div class="field-subtitle left">
            Your banner will be stored in drafts and will <u>not</u> be displayed in the app
          </div>
        </label>

        <span style="display: inline-block; margin-top: 20px">
          <p-radioButton
            name="display"
            [value]="+0"
            formControlName="displayType"
            id="displayActive"
          >
          </p-radioButton>
          <label for="displayActive" class="ml-2">
            <b>Active or Scheduled Banner</b>
            <div class="field-subtitle left">Your banner will be displayed in the app</div>
          </label>
        </span>
      </div>
    </div>
    <!-- end of field 4 -->

    <div class="field-box" *ngIf="f.displayType.value == BannerDisplayType.ActiveOrScheduled">
      <div class="field-number">
        <span>5</span>
      </div>
      <div class="field-title">
        Display Details*
        <div class="field-subtitle left">Active/Scheduled Banner</div>
      </div>

      <div style="flex-grow: 1">
        <div style="display: flex">
          <div class="field-input">
            <div class="input-title">Days of the Week</div>
            <p-dropdown
              name="displayWeeks"
              [options]="displayWeekValues"
              formControlName="displayWeek"
              [style]="{ width: '100%' }"
            ></p-dropdown>
          </div>

          <div class="field-input">
            <div class="input-title">Show From</div>
            <p-calendar
              [showTime]="false"
              name="showFrom"
              dateFormat="dd/mm/yy"
              formControlName="showFrom"
              [showIcon]="false"
              [inputStyle]="{ width: '100px' }"
            ></p-calendar>
          </div>

          <div class="field-input">
            <div class="input-title">Show Until</div>
            <p-calendar
              [showTime]="false"
              name="showUntil"
              dateFormat="dd/mm/yy"
              formControlName="showUntil"
              [showIcon]="false"
              placeholder="No Expiry"
            ></p-calendar>
          </div>
        </div>

        <!--      <div style="display: flex; margin-top: 20px">-->
        <!--        <div class="field-input">-->
        <!--          <div class="input-title">Position in Carousel Weekdays</div>-->
        <!--          <p-dropdown-->
        <!--            name="positionWeekdays"-->
        <!--            [options]="bannerPositionValues"-->
        <!--            formControlName="positionInCarouselWeekdays"-->
        <!--            [style]="{ width: '200px' }"-->
        <!--          ></p-dropdown>-->
        <!--        </div>-->

        <!--        <div class="field-input">-->
        <!--          <div class="input-title">Position in Carousel Weekends</div>-->
        <!--          <p-dropdown-->
        <!--            name="positionWeekdends"-->
        <!--            [options]="bannerPositionValues"-->
        <!--            formControlName="positionInCarouselWeekends"-->
        <!--            [style]="{ width: '200px' }"-->
        <!--          ></p-dropdown>-->
        <!--        </div>-->
        <!--      </div>-->
      </div>
    </div>
    <!-- end of field 5 -->

    <div class="field-box">
      <div class="field-number">
        <span>6</span>
      </div>
      <div class="field-title">
        Image*
        <div class="field-subtitle left">Recommended pixel size: 500 x 330</div>
      </div>

      <div class="field-input">
        <div class="upload empty" *ngIf="!presignedImageUrl">
          <ngx-file-drop
            name="files"
            id="files"
            (onFileDrop)="dropped($event)"
            class="engineius-file-drop"
          >
            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
              <div *ngIf="savingImage" class="upload-file-box">
                <i class="fa fa-spinner fa-spin fa-2x"></i> Uploading Image...
              </div>
              <div *ngIf="!savingImage" class="upload-file-box" (click)="openFileSelector()">
                <i class="fa fa-upload" aria-hidden="true"></i> Drag & drop or
                <span class="blue-link">choose file</span> to upload
              </div>
            </ng-template>
          </ngx-file-drop>
        </div>

        <small *ngIf="!presignedImageUrl" class="text-danger">An image is required</small>

        <div class="file-border" *ngIf="presignedImageUrl">
          <div
            style="color: red; cursor: pointer"
            pTooltip="Remove image"
            (click)="removeFile($event)"
          >
            <i class="fa fa-trash-o"></i>
          </div>
          <img [src]="presignedImageUrl" style="width: 100%" alt="" />
          <span *ngIf="loadingImage"><img src="assets/images/loader.gif" /> Loading...</span>

          <!--          <table style="width: 100%">-->
          <!--            <tr-->
          <!--              style="cursor: pointer"-->
          <!--              *ngFor="let file of files"-->
          <!--              (click)="openImagePresigned(file.imageLocation)"-->
          <!--            >-->
          <!--              <td style="width: 5%">-->
          <!--                <div style="margin: 4px 12px"><i class="fa fa-file-o"></i></div>-->
          <!--              </td>-->
          <!--              <td>-->
          <!--                <div>{{ file.fileName }}</div>-->
          <!--              </td>-->
          <!--              <td style="text-align: center">-->
          <!--                <div-->
          <!--                  style="color: red; cursor: pointer"-->
          <!--                  pTooltip="Remove image"-->
          <!--                  (click)="removeFile($event, file)"-->
          <!--                >-->
          <!--                  <i class="fa fa-trash-o"></i>-->
          <!--                </div>-->
          <!--              </td>-->
          <!--              <td style="text-align: center" *ngIf="file.imageLocation">-->
          <!--                <div pTooltip="View attachment">-->
          <!--                  <i class="fa fa-eye" style="color: #0082cb" aria-hidden="true"></i>-->
          <!--                </div>-->
          <!--              </td>-->
          <!--            </tr>-->
          <!--          </table>-->
        </div>
      </div>
    </div>
    <!-- end of field 6 -->

    <div class="field-box">
      <div class="field-number">
        <span>7</span>
      </div>
      <div class="field-title">
        Notes
        <div class="field-subtitle left">
          For internal use, this will not be displayed in the app
        </div>
      </div>
      <div class="field-input">
        <input
          pInputText
          class="input-text"
          placeholder="Input Notes"
          formControlName="notes"
          style="width: 100%"
        />
      </div>
    </div>
    <!-- end of field 7 -->

    <div class="row">
      <div
        style="
          display: flex;
          flex-wrap: wrap;
          grid-gap: 15px;
          justify-content: flex-end;
          padding: 0 15px 15px 0;
          margin-bottom: 10px;
        "
      >
        <div style="width: 68px; text-align: center; line-height: 38px">
          <span class="cancel-button" (click)="cancelEdit()"> Cancel </span>
        </div>
        <div style="flex-shrink: 1">
          <button
            [disabled]="!form.valid || !presignedImageUrl"
            pButton
            type="submit"
            [label]="
              f.displayType.value === BannerDisplayType.ActiveOrScheduled ? 'Publish' : 'Save Draft'
            "
            class="ui-button btn-to-right pull-right button-blue"
          ></button>
        </div>
      </div>
    </div>
  </form>
</div>
